'use strict';

const COOKIE_NAME = 'adsw';
const admin = [
  'cookieStorage',

  function (cookieStorage) {
    return {

      /**
       * Checks if current user is admin logged in as another user
       * @returns {boolean}
       */
      isAdmin: function () {
        return Boolean(cookieStorage.get(COOKIE_NAME));
      },

      /**
       * Deletes admin cookie
       */
      deleteCookie: function () {
        cookieStorage.remove(COOKIE_NAME);
      }
    };
  }
];

export default admin;



// WEBPACK FOOTER //
// ./app/src/services/admin.js